// extracted by mini-css-extract-plugin
export default {"root":"SliceHeader_root__8NLz2","description":"SliceHeader_description__-k6mR"};